import type { LibraryItemState } from '@/lib/api/generated/model';

/**
 * Whether the workspace already holds this item, whatever shape it is in.
 *
 * Every state but one says the item is here: installed, changed since, behind
 * the library, or put there by hand. The page uses this to mark a workflow's
 * dependencies that need no installing, and to count what this workspace has.
 */
export function isInWorkspace(state: LibraryItemState): boolean {
  return state !== 'not_installed';
}

/**
 * Whether the library has moved on from the copy this workspace holds.
 *
 * Two states say so: one where the copy here is untouched, and one where it has
 * been changed locally as well. Both are an update waiting; the difference is
 * what updating would cost, which the badge on the row already says.
 */
export function hasUpdate(state: LibraryItemState): boolean {
  return (
    state === 'update_available' ||
    state === 'update_available_with_local_changes'
  );
}
